import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { AxiosAdminInstance } from '../utils';
import { useParams } from 'react-router-dom';
import { DropDownComponent, InputComponent, CheckboxComponent, TextAreaComponent } from '../custcomponents';
import { toast } from 'react-toastify';


export  const Reports = () => {
    const { eventcode } = useParams();
  const [data, setData] = useState([]);
  const [filterType, setFilterType] = useState('Individual');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
const sortDates  = (rowA , rowB )  => {
 return  new Date(rowA.createdate).getTime() - new Date(rowB.createdate).getTime();
};

   const handleResendMail = async (row) => {
    try {
      await AxiosAdminInstance.post('/api/admin/resendEmail', {
        resenttype: 'IndividualRegistrationMail',
        eventcode: eventcode,
        emailid: row.personalmailid,
        orderid: row.paymentid
      });
      toast.success('Email resent successfully');
    } catch (error) {
      console.error('Error resending email:', error);
      toast.error('Failed to resend email: ' + String(error));
    }
  };
// Define columns
const columns = [
  {
    name: 'Actions',
    cell: (row) => (
      <button
        onClick={() => handleResendMail(row)}
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        title="Resend Email"
      >
        <i className="fa fa-envelope"></i>
      </button>
    ),
    width: '80px',
    center: true
  },
  { name: 'Name', selector: row => row.name, sortable: true },
  { name: 'paymentstatus', selector: row => row.paymentstatus, sortable: true },
  { name: 'paytype  ', selector: row => row.paytype  , sortable: false },
  { name: 'paymentid  ', selector: row => row.paymentid  , sortable: false },
  { name: 'personalmailid', selector: row => row.personalmailid, sortable: true },
  { name: 'phonenumber', selector: row => row.phonenumber, sortable: true },
  { name: 'tickettype', selector: row => row.tickettype, sortable: true },
  { name: 'title', selector: row => row.title, sortable: true },
  { name: 'tshirtsize', selector: row => row.tshirtsize, sortable: true },
  { name: 'company', selector: row => row.company, sortable: true },
  { name: 'createdate', selector: row => row.createdate, sortFunction: sortDates, sortable: true,  },
  { name: 'gender', selector: row => row.gender, sortable: true },
  { name: 'coupon  ', selector: row => row.couponcode  , sortable: false },
  { name: 'attended', selector: row => row.attended, sortable: true },
];
  // Fetch data from server on dropdown change
  const fetchDataByType = async (type) => {
    setLoading(true);
    try {
        var apiurl = '/api/admin/getregistrationslist?eventcode=' + eventcode;
      
        const { data: response } = await AxiosAdminInstance.get(apiurl);
        console.log(response);
        const enrichedData = (response.data || []).map(row => ({
          ...row,
          attended: row?.checkins?.attendance?.checkintime ? 'Yes' : 'No'
        }));
      setData(enrichedData);
    } catch (err) {
      console.error('Failed to fetch data:', err);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        const { data: response } = await AxiosAdminInstance.get('/api/admin/getregistrationslist?eventcode=' + eventcode);
        console.log(response);
        if (response.result != "Success" || response.data?.length == 0) {
            setData([]);
            setLoading(false);
            return;
        }
        console.log(response.data);
        const enrichedData = (response.data || []).map(row => ({
          ...row,
          attended: row?.checkins?.attendance?.checkintime ? 'Yes' : 'No'
        }));
        setData(enrichedData);
        setLoading(false);
    }
    fetchData();
}, []);
function convertArrayOfObjectsToCSV(array) {
	let result;

	const columnDelimiter = ',';
	const lineDelimiter = '\n';
	const keys = Object.keys(data[0]);

	result = '';
	result += keys.join(columnDelimiter);
	result += lineDelimiter;

	array.forEach(item => {
		let ctr = 0;
		keys.forEach(key => {
			if (ctr > 0) result += columnDelimiter;

			result += item[key];
			
			ctr++;
		});
		result += lineDelimiter;
	});

	return result;
}

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(e, array) {
	const link = document.createElement('a');
	let csv = convertArrayOfObjectsToCSV(array);
	if (csv == null) return;

	const filename = 'export.csv';

	if (!csv.match(/^data:text\/csv/i)) {
		csv = `data:text/csv;charset=utf-8,${csv}`;
	}

	link.setAttribute('href', encodeURI(csv));
	link.setAttribute('download', filename);
	link.click();
}

  // Trigger HTTP call when dropdown changes
  useEffect(() => {
    fetchDataByType('');
  }, []);

  // Local filter by search input (on already-fetched data)
  var filteredData = data;
  if(search && search != '')
  {
    filteredData= data.filter((item :  any) =>{
    return item.name.toLowerCase().includes(search.toLowerCase()) 
    || item.tickettype.toLowerCase().includes(search.toLowerCase()) 
    || item.company.toLowerCase().includes(search.toLowerCase()) 
    || (item.phonenumber && String(item.phonenumber).toLowerCase().includes(search.toLowerCase())) 
    || item.personalmailid.toLowerCase().includes(search.toLowerCase()) 
    || ( item.paymentstatus && item.paymentstatus.toLowerCase().includes(search.toLowerCase()))
    || (item.paytype && item.paytype.toLowerCase().includes(search.toLowerCase()))
    || ( item.paymentid && item.paymentid.toLowerCase().includes(search.toLowerCase()));
}
  
  );
  }

  return (
    <section className="register-sec sec-padding-admin" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-user fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">Registrations</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details ">
                    <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <a href={"/weba/managetransactions/" + eventcode}>Transaction Reports</a>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6">
                                        <a   href={"/weba/managegrppay/" + eventcode} >Group Pays Report</a>
                                        </div>
                                        </div>
                    <div className="row pt-2">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                    

<InputComponent custname="couponCode" custid="txtcouponcode" custplaceholder="Filter"   onExternalValue={setSearch} onExternalBind={search} />
                                    

    
                                        
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" data-wow-duration="300ms">
                                        <button type="button"  className="btn-default" onClick={(e) => downloadCSV(e, data)} >EXPORT  <i className="fa fa-arrow-circle-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                <DataTable
        columns={columns}
        data={filteredData}
        progressPending={loading}
        pagination
        highlightOnHover
        dense
        style={{ marginTop: '20px' }}
      />
      </div>
                                    </div>
                    </div>
                    </div>
                    </section>

  );
};

export default Reports;